import React, { Component, RefObject } from 'react';
import Pagenation from '../../molecules/Pagenation';
import { SearchResultItem, SearchResultState } from '../../../redux/reducers/SearchResultReducer';
import { LoadingStatus } from '../../../redux/reducers/LoadingStatusReducer';
import CircularProgress from '../../atoms/CircularProgress';
import {
  DEFAULT_PAGE_VIEW,
  GASpotEventMappingState,
  SESSION_STORAGE_NEGOTATION_KEYS,
  SORT_TYPE,
  SORT_TYPE_NAME,
  SORT_CONDITIONS_ORDER,
  ScrollInfo,
  getStorageValueByKey,
  setStorageValueByKey,
  sortButtonStatus,
} from '../../../Common';
import SearchResultItemComponent from '../../molecules/SearchResultItem';
import { MasterInfoState } from '../../../redux/reducers/MasterInfoReducer';
import Select from '../../atoms/Select';

export interface SearchResultTableHandler {
  searchResult: SearchResultState;
  loadingStatus: LoadingStatus;
}

interface SearchResultTableProps extends SearchResultTableHandler {
  search: (paging: ScrollInfo, sort: string) => void;
  paging: ScrollInfo;
  sort: string;
  sortButtonStatus: sortButtonStatus;
  currentPage: number;
  setCurrentPage: (pageNum: number) => void;
  apiUpdateIndex: number;
  setApiUpdateIndex: (apiUpdateIndex: number) => void;
  setSort: (sort: string) => void;
  masterInfo: MasterInfoState;
  setForceRefetchFlag?: () => void;
  sortSpotEvent: {
    [key: string]: GASpotEventMappingState;
  };
  actionSpotEvent: {
    [key: string]: GASpotEventMappingState;
  };
}

export interface SearchResultTableState {
  pageRows: number;
}

class SearchResultTable extends Component<SearchResultTableProps, SearchResultTableState> {
  private scrollRef: RefObject<HTMLDivElement>;

  constructor(props: SearchResultTableProps) {
    super(props);
    this.state = {
      pageRows: DEFAULT_PAGE_VIEW.RECORD_ROWS,
    };

    this.onSearch = this.onSearch.bind(this);
    this.scrollRef = React.createRef<HTMLDivElement>();
  }

  getViewList(searchResult: SearchResultItem[]): SearchResultItem[] {
    if (searchResult.length == 0) {
      return searchResult;
    }

    const hasDataList: SearchResultItem[][] = this.sliceArray(searchResult);
    const index: number = this.calcArrayIndex();
    return hasDataList[index];
  }

  sliceArray(array: SearchResultItem[]): SearchResultItem[][] {
    const { pageRows } = this.state;
    return array.reduce(
      (acc: SearchResultItem[][], c, i: number) => (i % pageRows ? acc : [...acc, ...[array.slice(i, i + pageRows)]]),
      [],
    );
  }
  calcArrayIndex(): number {
    const { pageRows } = this.state;
    const { paging, currentPage, apiUpdateIndex } = this.props;

    // キャッシュしてるページの半分件数:200件20ページ分キャッシュしてるので、10となる
    const halfPageCount = paging.size / 2 / pageRows;
    // キャッシュしたページ：初期値は11、初期値未満(<11)になったら、初期値で補填を行う。
    const _calcApiUpdateIndex = apiUpdateIndex < DEFAULT_PAGE_VIEW.API_UPDATE_INDEX ? DEFAULT_PAGE_VIEW.API_UPDATE_INDEX : apiUpdateIndex;
    // キャッシュしてるページの開始インデックス(1始まり)
    const startPage = _calcApiUpdateIndex - halfPageCount < 0 ? 0 : _calcApiUpdateIndex - halfPageCount;
    // キャッシュしてるページ配列のインデックス(0始まり)
    const durationForCurrentPage = currentPage - startPage;

    return durationForCurrentPage;
  }

  reCalcFrom(index: number) {
    const { pageRows } = this.state;
    const { paging } = this.props;
    const halfPageCount = paging.size / 2 / pageRows;
    const calcStartIndex = index - halfPageCount - 1 < 0 ? 0 : index - halfPageCount - 1;
    return calcStartIndex * this.state.pageRows;
  }

  // TODO onSearch と onSearchTestを共通化
  onSearch(from: number) {
    const newPaging = Object.assign({}, this.props.paging);
    newPaging.from = from;
    this.props.search(newPaging, this.props.sort);
  }

  onSearchTest(sort: string) {
    this.props.search(this.props.paging, sort);
  }

  /**
   * 最上部にスクロール
   */
  scrollToTop() {
    if (this.scrollRef.current) this.scrollRef.current.scrollTop = 0;
  }

  // ボタンを廃止したので関連のGAイベントも廃止
  // addGASpotEventIntoSortButtons() {
  //   Object.values(this.props.sortSpotEvent).forEach(({ spotEvent, className }) => {
  //     document.querySelector(`.${className}`)?.setAttribute('onclick', spotEvent || '');
  //   });
  // }

  componentDidUpdate(prevProps: SearchResultTableProps): void {
    const { currentPage, setCurrentPage, setApiUpdateIndex, setForceRefetchFlag } = this.props;
    // ボタンを廃止したので関連のGAイベントも廃止
    // if (this.props.sortButtonStatus) {
    //   this.addGASpotEventIntoSortButtons();
    // }
    if (prevProps.searchResult === this.props.searchResult) {
      return;
    }
    const newMaxPage = Math.ceil(this.props.searchResult.hit / 10);
    // このケースは、最後のページに要素が 1 つしかない場合で、それを削除する。
    if (currentPage > newMaxPage) {
      // 「currentPage > newMaxPage」は、データを削除し、商談一覧に戻るときに、currentPage が総ページ数より大きい です。 (つまり、最後のページがもう存在しない)
      // currentPageは現在のmaxPageで再度セットし、古いApiUpdateIndex (oldApiUpdateIndex) に従ってデータを戻すためにApiUpdateIndexを再度セットする必要がある。
      // ページに戻ると、ApiUpdateIndex が元の値に再度セットされるため。
      const newCurrentPage = newMaxPage;
      setCurrentPage(newCurrentPage);
      if (!this.props.searchResult.searchResultList.length) {
        setApiUpdateIndex(newCurrentPage < DEFAULT_PAGE_VIEW.API_UPDATE_INDEX ? DEFAULT_PAGE_VIEW.API_UPDATE_INDEX : newCurrentPage);
        const paging = JSON.parse(getStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE));
        if (paging) {
          paging.from = this.reCalcFrom(newMaxPage);
          setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE, paging);
        }
        setForceRefetchFlag && setForceRefetchFlag();
      }
    }
    if (this.props.searchResult.searchResultList.length > 0 && currentPage === 0) {
      setCurrentPage(DEFAULT_PAGE_VIEW.CURRENT_PAGE);
      setApiUpdateIndex(DEFAULT_PAGE_VIEW.API_UPDATE_INDEX);
    }
  }

  render() {
    const { isLoading, result } = this.props.loadingStatus;
    const today = result?.jobDateTime ?? '';
    const searchResult = this.getViewList(this.props.searchResult.searchResultList) || [];

    const handleChangeSortDropdown = (selected: string) => {
      if (this.props.sort === selected) {
        return;
      }
      this.props.setSort(selected);
      this.onSearchTest(selected);
      setStorageValueByKey(SESSION_STORAGE_NEGOTATION_KEYS.SORT_TYPE, selected);
    };

    // 並び順プルダウン
    const renderSortPullDown = (sort: string) => {
      /**
       * 並び順プルダウン定義
       * SORT_TYPE、SORT_TYPE_NAME、SORT_CONDITIONS_ORDERから動的に生成
       */
      const sortConditions: { key: string; label: string }[] = SORT_CONDITIONS_ORDER.map((sortKey) => ({
        key: SORT_TYPE[sortKey],
        label: SORT_TYPE_NAME[sortKey],
      }));

      return (
        <Select
          className='uc-card__header-right'
          value={sort}
          onChange={(e) => handleChangeSortDropdown(e.target.value)}
          data-testid={`searchResult-sort-dropdown`}
          data-testid-e2e={`searchResult-sort-dropdown`}>
          {sortConditions.map((item) => (
            <Select.Option value={item.key} key={item.key}>
              {item.label}
            </Select.Option>
          ))}
        </Select>
      );
    };

    return (
      <>
        {isLoading ? (
          <div className='u-flex u-h-viewport u-items-center u-justify-center' data-testid='loadingArea'>
            <div className='u-text-center'>
              <CircularProgress isIndeterminate hasBackground={false} />
              <p>ページを読み込んでいます...</p>
            </div>
          </div>
        ) : (
          <>
            <div className='clearfix u-mb16'>
              <div className='u-float-left'>{renderSortPullDown(this.props.sort)}</div>
              <div className='u-float-right'>
                {/* ページネーション */}
                {searchResult.length > 0 && (
                  <Pagenation
                    maxNum={this.props.searchResult.hit}
                    existNum={this.props.searchResult.searchResultList.length}
                    pageRows={this.state.pageRows}
                    currentPage={this.props.currentPage}
                    setCurrentPage={(pageNum: number) => {
                      this.props.setCurrentPage(pageNum);
                      this.scrollToTop();
                    }}
                    apiUpdateIndex={this.props.apiUpdateIndex}
                    setApiUpdateIndex={(apiUpdateIndex: number) => this.props.setApiUpdateIndex(apiUpdateIndex)}
                    scrollSize={this.props.paging.size}
                    search={(from) => this.onSearch(from)}
                    isRight
                    data-testid='pagenation'
                  />
                )}
              </div>
            </div>
            <div className='search-result-card-list' ref={this.scrollRef}>
              <ul>
                {searchResult.map((data: SearchResultItem, index: number) => {
                  return (
                    <SearchResultItemComponent
                      today={today}
                      index={index}
                      key={data.key}
                      ownStoreFlg={data.ownStoreFlg}
                      updateDate={data.updateDate}
                      createDate={data.createDate}
                      negotiationId={data.negotiationId}
                      customerId={data.customerId}
                      customerNumber={data.customerNumber}
                      ordcstmName={data.ordcstmName}
                      closingSalesmanName={data.closingSalesmanName}
                      otherSalesmanName={data.otherSalesmanName}
                      ymFlg={data.ymFlg}
                      customerFullName={data.customerFullName}
                      projectCd={data.projectCd}
                      keep={data.keep}
                      cncgPrintNo={data.cncgPrintNo}
                      tempCd={data.tempCd}
                      dummyFlg={data.dummyFlg}
                      negotiationResultProductInfo={data.negotiationResultProductInfo}
                      data-testid='searchResultItemComponent'
                      externalSystemLink1={data.externalSystemLink1}
                      masterInfo={this.props.masterInfo}
                      resurrectionFlg={data.resurrectionFlg}
                      resurrectionDate={data.resurrectionDate}
                      negotiationNote={data.negotiationNote}
                      customerCreateDate={data.customerCreateDate}
                      customerLatestUpdateDate={data.customerLatestUpdateDate}
                      expirationDate={data.expirationDate}
                      actionSpotEvent={this.props.actionSpotEvent}
                      hasNegotiationAttachedFile={data.hasNegotiationAttachedFile}
                    />
                  );
                })}
                {searchResult.length === 0 && (
                  <li className='search-result-card is-no-result' data-testid='searchResult'>
                    商談が見つかりません。
                  </li>
                )}
              </ul>
            </div>
          </>
        )}
      </>
    );
  }
}
export default SearchResultTable;
